import React, { forwardRef, useMemo } from 'react'
import Tippy from '@tippyjs/react/headless'
import { Z_INDEX } from 'styles/z-index'

interface NavTooltipProps {
  children: React.ReactElement
  label: string
}

// Wrapper component that forwards ref to the child element
const TriggerWrapper = forwardRef<
  HTMLElement,
  { children: React.ReactElement }
>(({ children, ...props }, ref) => {
  return React.cloneElement(children, { ...props, ref } as any)
})
TriggerWrapper.displayName = 'TriggerWrapper'

export const NavTooltip: React.FC<NavTooltipProps> = ({ children, label }) => {
  const rootElement = useMemo(
    () => document.getElementById('root') as HTMLElement,
    []
  )

  return (
    <Tippy
      placement="right"
      offset={[0, 8]}
      delay={[100, 0]}
      appendTo={() => rootElement}
      render={(attrs) => (
        <div
          className="h-6 px-2 py-1 bg-sage-lt rounded text-fg text-xs font-medium font-['Inter'] whitespace-nowrap flex items-center justify-center"
          style={{
            boxShadow: '0px 4px 8px 3px rgba(6, 81, 47, 0.1)',
            zIndex: Z_INDEX.TOOLTIP,
          }}
          role="tooltip"
          {...attrs}
        >
          {label}
        </div>
      )}
    >
      <TriggerWrapper>{children}</TriggerWrapper>
    </Tippy>
  )
}
